import { CustomCSS, imageField, urlField, textField } from "./CustomCSS.ts";
import type { TemplateOptions } from "./Madara.ts";
export function MangaThemesia(options: TemplateOptions) {
  const listing = {
    kind: "html" as const,
    selector: ".listupd .bs, .bsx",
    emptySelector: ".notf",
    fields: { title: textField(".tt, h2"), url: urlField("a"), coverUrl: imageField("img", false) },
  };
  return CustomCSS({
    schemaVersion: 1,
    template: "MangaThemesia",
    requiresSession: true,
    ui: { idMode: "url", mangaPath: "/manga/", chapterPath: "/" },
    latest: { steps: [{ url: "{baseUrl}/manga/?page={page}&order=added", capture: { nextUrl: urlField(".hpage .r, a.next", false) }, extract: listing }] },
    catalog: {
      steps: [
        {
          url: "{baseUrl}/manga/?page={page}",
          capture: { nextUrl: urlField(".hpage .r, a.next", false) },
          extract: listing,
        },
      ],
    },
    ...options,
    operations: options.operations ?? {
      search: { steps: [{ url: "{baseUrl}/?s={query}&page={page}", extract: listing }] },
      detail: {
        steps: [
          {
            url: "{manga.url}",
            extract: {
              kind: "html",
              fields: {
                title: textField("h1.entry-title, h1"),
                description: textField(".entry-content .summary, .synp", false),
                coverUrl: imageField(".thumb img", false),
              },
            },
          },
        ],
      },
      chapters: {
        steps: [
          {
            url: "{manga.url}",
            extract: {
              kind: "html",
              selector: "#chapterlist a, .eplister a",
              fields: { name: textField(".chapternum"), url: urlField() },
            },
          },
        ],
      },
      pages: {
        steps: [
          {
            url: "{chapter.url}",
            referer: "{baseUrl}",
            extract: {
              kind: "html",
              selector: ".reader-area img, #readerarea img",
              fields: { url: imageField() },
            },
          },
        ],
        fallbacks: [
          {
            steps: [
              {
                url: "{chapter.url}",
                referer: "{baseUrl}",
                extract: {
                  kind: "json",
                  decoder: { kind: "builtin", name: "themesia-pages" },
                  fields: { url: { transforms: ["absolute-url"], asset: true } },
                },
              },
            ],
          },
        ],
      },
    },
  });
}
